// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__tDChW","text":"SelectPayment_text__2Bvp6","title":"SelectPayment_title__n5mNr","btn":"SelectPayment_btn__wV7Lr"};